import { ArrowRightIcon } from 'lucide-react'
import React from 'react'

import { Button } from 'slab'

import { type UseProviderInNetworkVerificationModalProps } from './useProviderInNetworkVerificationModal'
import { useProviderInNetworkVerificationContext } from '../ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'

export const ProviderInNetworkVerificationBanner: React.FC<UseProviderInNetworkVerificationModalProps> = (props) => {
  const { launchModal } = useProviderInNetworkVerificationContext()
  return (
    <>
      <div className='p-4 border rounded-lg bg-slate-50 border-slate-300'>
        <div className='body-bold font-medium text-slate-500'>Want us to call your providers?</div>
        <div className='mt-3 mb-4'>We share the most up-to-date data on whether your providers take a given insurance, but it can change pretty frequently. If you'd like, we can call your providers to double-check with them. (Standard turnaround is 1–3 business days.)</div>
        <Button variant='secondary' onClick={() => launchModal(props)} rightIcon={ArrowRightIcon}>
          Get started
        </Button>
      </div>
    </>
  )
}
